import { useCallback, useLayoutEffect, useRef } from "react";

// Prevents useEffect/useCallback dep arrays from re-firing when Apollo returns a new
// `refetch` reference on every render. useLayoutEffect (not render-time mutation) keeps
// the ref update concurrent-mode safe — React can discard renders but not layout effects.
const useStableCallback = (fn) => {
  const ref = useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  });
  return useCallback((...args) => ref.current(...args), []);
};

export default useStableCallback;
